<template>
  <CRow>
    <CCol>
      <CCard>
        <div class="judul">
          <strong>Detail Pengajuan</strong>
        </div>
        <CCardHeader>
          <strong>Diri Pendaftar</strong>
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="ID Registration"
                class="mb-0"
                placeholder="ID Registration"
                v-model.trim="agentData.agent_id"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Bentuk Pengajuan"
                class="mb-0"
                placeholder="Bentuk Pengajuan"
                v-model.trim="agentData.registration_type"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Pendaftar"
                class="mb-0"
                placeholder="Nama Pendaftar"
                v-model.trim="agentData.register_name"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Pendaftar"
                class="mb-0"
                placeholder="Alamat Pendaftar"
                v-model.trim="agentData.register_address"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="No HP"
                class="mb-0"
                placeholder="NO HP"
                v-model.trim="agentData.phone_number"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Email Pendaftar"
                class="mb-0"
                placeholder="Email Pendaftar"
                v-model.trim="agentData.register_email"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="No HP2"
                class="mb-0"
                placeholder="NO HP2 "
                v-model.trim="agentData.phone_number_two"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Darimana Anda mendapatkan informasi tentang pendaftaran ini"
                class="mb-0"
                v-model.trim="agentData.resource"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader v-if="agentData.registration_type === 'Badan Usaha'">
          <strong>Data Perusahaan</strong>
        </CCardHeader>
        <CCardBody v-if="agentData.registration_type === 'Badan Usaha'">
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Jenis Perusahaan"
                class="mb-0"
                placeholder="Jenis Perusahaan"
                v-model.trim="agentData.company_type"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Nama ketua perusahaan"
                class="mb-0"
                placeholder="Nama ketua perusahaan"
                v-model.trim="agentData.company_chairman_name"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Perusahaan"
                class="mb-0"
                placeholder="Nama Perusahaan"
                v-model.trim="agentData.company_name"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Perusahaan"
                class="mb-0"
                placeholder="Alamat Perusahaan"
                v-model.trim="agentData.company_address"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader>
          <strong>Data Lokasi</strong>
        </CCardHeader>

        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Lokasi"
                class="mb-0"
                placeholder="Lokasi"
                v-model.trim="agentData.building_location"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Jenis Bangunan"
                class="mb-0"
                placeholder="Jenis Bangunan"
                v-model.trim="agentData.building_type"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Status Bangunan"
                class="mb-0"
                placeholder="Status Bangunan"
                v-model.trim="agentData.building_status"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Lokasi"
                class="mb-0"
                placeholder="Alamat Lokasi"
                v-model.trim="agentData.address_location"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Provinsi"
                class="mb-0"
                placeholder="Provinsi"
                v-model.trim="agentData.province"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Kota"
                class="mb-0"
                placeholder="Kota"
                v-model.trim="agentData.district"
                disabled
              />
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Kecamatan"
                class="mb-0"
                placeholder="Kecamatan"
                v-model.trim="agentData.sub_district"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Kelurahan"
                class="mb-0"
                placeholder="Kelurahan"
                v-model.trim="agentData.village"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader>
          <!-- <strong>Data Perusahaan</strong> -->
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Apakah bersedia pickup ke customer?"
                class="mb-0"
                placeholder="Apakah bersedia pickup ke customer?"
                v-model.trim="isPickup"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Apakah ada pengalaman di bidang pengiriman/logistik?"
                class="mb-0"
                placeholder="Apakah ada pengalaman di bidang pengiriman/logistik?"
                v-model.trim="isLogistic"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Apakah ada kenalan online shop di wilayah anda?"
                class="mb-0"
                placeholder="Apakah ada kenalan online shop di wilayah anda?"
                v-model.trim="isLogistic"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Latitude & Longitude"
                class="mb-0"
                placeholder="Latitude & Longitude"
                v-model.trim="agentData.latlong"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group align-items-end">
            <CCol :col="6">
              <CInput
                label="Apakah bersedia melakukan drop off paket ke shuttle / konsolidator terdekat?"
                class="mb-0"
                placeholder="Apakah bersedia melakukan drop off paket ke shuttle / konsolidator terdekat?"
                v-model.trim="isDropOff"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Apakah bersedia melakukan Top Up pertama senilai Rp. 5.000.000?"
                class="mb-0"
                placeholder="Apakah bersedia melakukan Top Up pertama senilai Rp. 5.000.000?"
                v-model.trim="isTopUp"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group align-items-end">
            <CCol :col="6">
              <CInput
                label="Apakah Anda Mempunya Usaha Lain?"
                class="mb-0"
                placeholder="Apakah Anda Mempunya Usaha Lain?"
                v-model.trim="isHaveOtherBusiness"
                disabled
              />
            </CCol>
            <CCol
              v-if="agentData.other_business"
              :col="6"
            >
              <CInput
                class="mb-0"
                v-model.trim="agentData.other_business"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader><strong>UTM</strong></CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Source"
                class="mb-0"
                placeholder="UTM Source"
                v-model.trim="agentData.utm_source"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Medium"
                class="mb-0"
                placeholder="UTM Medium"
                v-model.trim="agentData.utm_medium"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Campaign"
                class="mb-0"
                placeholder="UTM Campaign"
                v-model.trim="agentData.utm_campaign"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Term"
                class="mb-0"
                placeholder="UTM Term"
                v-model.trim="agentData.utm_term"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Content"
                class="mb-0"
                placeholder="UTM Content"
                v-model.trim="agentData.utm_content"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader></CCardHeader>

        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6" v-if="agentData.referral_code !== undefined">
              <CInput
                label="Referral Code"
                class="mb-0"
                placeholder="Referral Code"
                v-model.trim="agentData.referral_code"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Created Date"
                class="mb-0"
                placeholder="Created Date"
                v-model.trim="agentData.created_at"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="agentData.flag === 'APPROVE'">
            <CCol :col="6">
              <CInput
                label="Pos Name"
                class="mb-0"
                v-model.trim="agentData.pos_name"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Pos Code"
                class="mb-0"
                v-model.trim="agentData.pos_code"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Status Pengajuan"
                class="mb-0"
                v-model.trim="agentData.flag"
                disabled
              />
            </CCol>
          </CRow>
          <CRow
            v-for="(item, index) of imageAgent"
            class="form-group"
            :key="`${item.label}-${index}`"
          >
            <CCol :col="3">
              <span>{{ item.label }}</span>
            </CCol>
            <CCol :col="6">
              <a
                v-if="Boolean(item.src)"
                :href="item.src"
                target="_blank"
              >
                <img
                  :src="item.src"
                  :alt="item.alt"
                  class="attachment-support"
                >
            </a>
              <p v-else>{{ item.error }}</p>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
        <CCardBody>
          <div class="judul">
            <strong>History Approval</strong>
          </div>

          <CDataTable hover :items="agentData.histories" :fields="fields">
            <template #attachment_registration="data">
              <td>
                <div v-if="data.item.attachment_registration !== undefined">
                  <div
                    v-if="
                      validateAttachmentRegistration(
                        data.item.attachment_registration
                      )
                    "
                  >
                    No File Attachment
                  </div>
                  <div v-else>
                    <select
                      class="select-custom"
                      required
                      @change="handleDownloadAttachment"
                      v-model="selectedFile"
                    >
                      <option hidden selected>{{ titleSelectedFile }}</option>
                      <option
                        v-for="(file, index) in requestFile"
                        :value="data.item.attachment_registration[index]"
                        :hidden="
                          data.item.attachment_registration[index] === '' ||
                          data.item.attachment_registration[index] === undefined
                        "
                        :key="index"
                      >
                        {{ file.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-else>No File Attachment</div>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";
import AgentRegistrationUseCase from "./app/usecase/index.js";
import ACCOUNT_GROUP from "../../../../app/enum/groups.js";
import { BOOLEAN_STRING } from "./app/enum/index.js";

export default {
  name: "ListingDetail",

  data() {
    return {
      agentData: {},
      optionsFollowUp: ["FOLLOW UP 1", "APPROVE FOLLOW UP", "REJECT"],
      optionsApprove: ["Calon agen sudah melengkapi data"],
      optionsReject: [
        "Calon agen hanya mencari informasi",
        "Calon agen keberatan dengan S&K Keagenan (Deposit)",
        "Calon agen keberatan dengan S&K Keagenan (Drop Off)",
        "Calon agen keberatan dengan S&K Keagenan (Marketplace)",
        "Calon agen keberatan dengan S&K Keagenan (Operasional)",
        "Calon agen keberatan dengan S&K Keagenan (Target)",
        "Calon agen memiliki usaha sejenis",
        "Calon agen tidak melengkapi data",
        "Calon agen tidak memiliki lokasi",
        "Lokasi berdekatan dengan POS lain",
        "Lokasi kurang strategis",
        "Lokasi terlalu jauh dari perwakilan",
        "Nomor tidak dapat dihubungi",
        "Tidak ada perwakilan di daerah tersebut",
      ],
      requestFile: [
        { label: "Fotokopi Akte Perusahaan", key: "attachment_deed", file: "" },
        { label: "Fotokopi SIUP", key: "attachment_siup", file: "" },
        { label: "Fotokopi TDP", key: "attachment_tdp", file: "" },
        { label: "Fotokopi NPWP", key: "attachment_npwp", file: "" },
        {
          label: "Fotokopi KTP Pemilik/Direktur",
          key: "attachment_ktp",
          file: "",
        },
        {
          label: "Fotokopi Buku Rekening",
          key: "attachment_bank_account",
          file: "",
        },
        {
          label: "Titik koordinat/foto lokasi",
          key: "attachment_location",
          file: "",
        },
        {
          label: "Foto Tempat Perusahaan",
          key: "attachment_business_place",
          file: "",
        },
        {
          label: "Bukti Transfer Top Up",
          key: "attachment_transfer",
          file: "",
        },
      ],
      items: [],
      flag: "",
      flag2: "",
      fields: [
        { key: "flag", label: "Action" },
        { key: "flag", label: "Status Pengajuan" },
        { key: "reason", label: "Reason" },
        { key: "created_by", label: "Created By" },
        { key: "created_at", label: "Created Date" },
        { key: "attachment_registration", label: "File Attachment" },
      ],
      titleSelectedFile: "List File Attachment",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      isPickup: BOOLEAN_STRING.NO,
      isLogistic: BOOLEAN_STRING.NO,
      isOlshop: BOOLEAN_STRING.NO,
      isDropOff: BOOLEAN_STRING.NO,
      isTopUp: BOOLEAN_STRING.NO,
      isHaveOtherBusiness: BOOLEAN_STRING.NO
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
    this.selectedFile = this.titleSelectedFile;
  },
  computed: {
    imageAgent() {
      return [
        {
          label: 'KTP',
          alt: 'Foto KTP agent',
          src: this.agentData.agent_identity,
          error: 'Foto KTP tidak ada'
        },
        {
          label: 'Lokasi Tampak Depan',
          alt: 'Foto lokasi tampak depan',
          src: this.agentData.agent_location_front,
          error: 'Foto lokasi tampak depan tidak ada'
        },
        {
          label: 'Lokasi Tampak Dalam',
          alt: 'Foto lokasi tampak dalam',
          src: this.agentData.agent_location_in,
          error: 'Foto lokasi tampak dalam tidak ada'
        },
      ]
    }
  },
  methods: {
    async getDataByID() {
      let agentID = this.$route.params.id;
      try {
        const { data, err } = await AgentRegistrationUseCase.getOne(agentID);
        if (err) {
          this.err = err;
          await this.$swal.fire({
            icon: "error",
            text: err,
          });
        } else {
          this.err = "";
          if (data) {
            this.agentData = data;
            this.validateBoolean();
            this.items = [this.agentData];
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validateBoolean() {
      if (this.agentData.is_pickup) {
        this.isPickup = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_logistic) {
        this.isLogistic = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_olshop) {
        this.isOlshop = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_drop_off) {
        this.isDropOff = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_top_up) {
        this.isTopUp = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_have_other_business) {
        this.isHaveOtherBusiness = BOOLEAN_STRING.YES;
      }
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === ACCOUNT_GROUP.NPOS ||
        data.account_group === ACCOUNT_GROUP.ADMIN ||
        data.account_group === ACCOUNT_GROUP.ADMINISTRATOR
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/agent/listing" });
    },
    handleReason(event) {
      this.agentData.reason = event;
    },
    handleReasonSelectApprove(event) {
      if (event.target.value !== "Other") {
        this.agentData.reason = event.target.value;
      }
      if (event.target.value === "Other") {
        this.flag2 = "Other";
      } else {
        this.flag2 = "";
      }
    },
    handleSelectReject(event) {
      this.agentData.flag = event.target.value;
    },
    handleChooseFlag(event) {
      this.agentData.flag = event.target.value;
      this.flag = event.target.value;
    },
    handleDownloadAttachment(event) {
      window.open(event.target.value);
      this.selectedFile = this.titleSelectedFile;
    },
    validateAttachmentRegistration(attachment) {
      var isHaveAttachment = false
      if (attachment !== undefined) {
       isHaveAttachment = attachment.every(function (file) {
          return file === "";
        });
      }
      return isHaveAttachment
    },
    update() {
      let accountID = this.$route.params.id;
      axios
        .put(`${this.domain}/v1/agent/${accountID}`, this.agentData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Account Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/agent/follow-up` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Some Data Is missing or invalid",
          });
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "./Agent.css";
</style>
